import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import LoginPage from './LoginPage';
import useAuth from '../hooks/useAuth';

function AuthWrapper({ children }) {
  const { user, isLoading, isAuthenticated, authRequired, checkAuth } = useAuth();

  if (isLoading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        sx={{ backgroundColor: 'background.default' }}
      >
        <CircularProgress color="primary" size={48} />
        <Typography variant="body1" color="textSecondary" sx={{ mt: 2 }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  if (authRequired && !isAuthenticated) {
    return <LoginPage onLoginSuccess={() => checkAuth()} />;
  }

  return <>{children}</>;
}

export default AuthWrapper;
